<template>
  <div class="m-l-50 m-t-30 w-500">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="接口名称" prop="name">
        <el-input v-model.trim="form.name" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="父级接口" prop="parent">
        <el-select v-model="form.parent" placeholder="请选择分类级别" class="w-200">
          <el-option v-for="item in parents" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模块" prop="module">
        <el-input v-model.trim="form.module" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="控制器" prop="controller">
        <el-input v-model.trim="form.controller" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading">提交</el-button>
        <el-button @click="goback()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import http from '../../../assets/js/http'
  export default {
    data() {
      return {
        isLoading: false,
        rules: {
          name: [
            { required: true, message: '请输入接口名称' }
          ],
          parent: [
            { required: true, message: '请选择父级接口' }
          ],
          module: [
            { required: true, message: '请输入模块' }
          ],
          controller: [
            { required: true, message: '请输入控制器' }
          ]
        },
        form: {
          name: '',
          parent: '',
          module: '',
          controller: ''
        },
        parents: [
          { id: 0, name: '无' }
        ]
      }
    },
    created() {
      this.getParents()
    },
    methods: {
      getParents() {
        let postData = {
          params: {
            parent: 0
          }
        }
        this.apiGet('admin/docs', postData).then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.parents = this.parents.concat(res.data)
          } else {
            _g.dealError(this, res)
          }
        })
      },
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPost('admin/docs', this.form).then((res) => {
              if (res.code == 200) {
                _g.toastMsg(this, 'success', '添加成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              } else {
                this.isLoading = !this.isLoading
                _g.dealError(this, res)
              }
            })
          }
        })
      },
      goback() {
        router.go(-1)
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// add.vue?21be7949